export const INTRO = 'intro';
export const MATCH = 'match';
export const MATH = 'math';
export const MEMORY = 'memory';
export const MOLE = 'mole';
export const PRECISION = 'precision';
export const FRUITS = 'fruits';
